/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { usePeopleQuery } from "~/generated/graphql";

export function usePerson(id: string | undefined | null) {
  const { data } = usePeopleQuery();
  const person = data?.people?.find((item) => item?.id === id);

  return { person };
}
